const fontStyle = {
  fontSize: { xs: '8px', sm: '10px', md: '12px', lg: '16px', xl: '18px' },
};

export default fontStyle;
